import React, { useState } from "react";
import AsyncSelect from "react-select/async";

type Lotacao = {
    id: number;
    descricao: string;
};

type Props = {
    inputName: string;
    value?: Lotacao;
    placeholder?: string;
    className?: string;
    containerClassName?: string;
    isClearable?: boolean;
    autocompleteUrl: string;
};

export function AutocompleteLotacao({
                                        inputName,
                                        value,
                                        placeholder = "Digite o nome da lotação...",
                                        className,
                                        containerClassName,
                                        isClearable = true,
                                        autocompleteUrl
                                    }: Props) {
    const [selected, setSelected] = useState<any>(
        value ? { id: value.id, text: value.descricao } : null
    );

    const loadOptions = async (inputValue: string) => {
        if (inputValue.length < 2) return [];
        const response = await fetch(`${autocompleteUrl}?q=${encodeURIComponent(inputValue)}`);
        return await response.json();
    };


    return (
        <div className={containerClassName}>
            <AsyncSelect
                cacheOptions
                defaultOptions
                loadOptions={loadOptions}
                onChange={(option) => setSelected(option)}
                value={selected}
                getOptionValue={(l) => (l?.id ?? '').toString()}
                getOptionLabel={(l) => l?.text ?? ''}
                className={`basic-single ${className}`}
                classNamePrefix="autocomplete"
                placeholder={placeholder}
                isClearable={isClearable}
                name={inputName}
                components={{ DropdownIndicator: null }}
                styles={{
                    menuList: (base) => ({
                        ...base,
                        maxHeight: 130,
                        overflowY: 'auto',
                    }),
                }}
            />
        </div>
    );
}
